import { Address } from './address.model';
import { AuditItem } from './aud-audit-item.model';
import { Library } from './aud-library.model';
import { GeoDsMeta } from './meta-data.model';
export class Audit extends GeoDsMeta{
  AuditDate: Date;
  Score?: number;
  MaxScore?: number;
  Percentage?: number;
  Designation: string;
  AllAuditItems?: AuditItem[];
  Library: Library;
  Company: Address;
  ParentId: string;
  IdRefAuditPerson?: string;
}